export default __webpack_public_path__ + "content/279f38601f1d1655255f21db0691ab37.ttf";